import React from 'react';
import { SHOW_PARAMS } from "../../../../config";

const TotalRow = ({ data }) => {
    const style = { fontSize: '18px', fontWeight: 'bold', textAlign: 'center' };
    const valuesTd = SHOW_PARAMS.map(param => <td style={style} key={param}>{data[param]}</td>);

    return (
        <tr>
            <td colSpan={3} style={style}>Total</td>
            {valuesTd}
        </tr>
    );
};

export default TotalRow;


// WEBPACK FOOTER //
// ./src/scenes/PushapiExtended/components/Table/components/TotalRow/index.js